import React from "react";
import { MaterialDesignIcons } from "../styled";

export const ForwardMIcon: React.FC<{ fontSize?: string }> = ({ fontSize }) => {
  return <MaterialDesignIcons fontSize={fontSize}>forward</MaterialDesignIcons>;
};
